import { render, staticRenderFns } from "./AddCandidateModal.vue?vue&type=template&id=77452715"
import script from "./AddCandidateModal.vue?vue&type=script&lang=js"
export * from "./AddCandidateModal.vue?vue&type=script&lang=js"
import style0 from "./AddCandidateModal.vue?vue&type=style&index=0&id=77452715&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports